<template>
  <div class="context">
    <div class="loginplat">
      <a-form
        ref="formLogin"
        class="forms"
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item>
          <a-input
            size="large"
            type="text"
            class="login-item"
            placeholder="用户名"
            v-decorator="[
                'username',
                {rules: [{ required: true, message: '请输入帐户名或邮箱地址' }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
              ]"
          >
            <a-icon slot="prefix" type="user" :style="{ color: '#D8160E' }" />
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-input
            size="large"
            type="password"
            class="login-item"
            autocomplete="false"
            placeholder="密码"
            v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: '#D8160E' }" />
          </a-input>
        </a-form-item>

        <a-form-item v-if="settings.identifyCodeOpen == '1'" :validate-status="identifyCodeStatus" :help="identifyCodeHelp">
        <div class="identifyCode">
          <Identify ref="loginIdentify" :codeLength="4" :codeType="this.settings.identifyCodeType" :contentWidth="120" @identifyCode="getIdentifyCode" class="identifyCodeid"></Identify>
         <a-input size="large" type="text" placeholder="验证码" class="identifyCodei"
            v-model="identifyCodeIn"
            v-decorator="[
              'identifyCodei',
              {rules: [{ required: true, message: '请输入验证码' }, { validator: handleIdentifyCode }], validateTrigger: 'blur'}
            ]"
          >
          </a-input>
        </div>
      </a-form-item>

        <a-form-item>
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-item"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >登录</a-button>
        </a-form-item>
      </a-form>

      <div class="modal-bg" v-show="isNotChrome">
        <div class="modal-container">请使用谷歌浏览器打开：<a href="http://app.hstscale.com/common/ChromeSetup.exe">下载地址</a></div>
      </div>

      <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    ></two-step-captcha>
  </div>
    </div>
  </div>
</template>

<script>
// import md5 from 'md5'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getSmsCaptcha, get2step } from '@/api/login'
import { settingsList } from '@/api/sys'
import storage from '@/utils/storage'
import { getCompanyInfo } from '@/api/basic'
import Bus from '@/layouts/bus'
import Identify from '@/components/identify/identify'
import config from '../../utils/config'

export default {
  components: {
    TwoStepCaptcha
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      companyName: '',
      companyLogoId: '',
      identifyCode: null, // 生成的验证码
      identifyCodeIn: null, // 输入的验证码
      identifyCodeStatus: 'success', // 验证码提示状态
      identifyCodeHelp: '', // 验证码提示信息
      // 读取系统配置
      settings: {},
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      },
      isNotChrome: false
    }
  },
  components: {
    Identify
  },
  created() {
    // this.companyName = '安陆顺安矿业有限公司售料系统'
    // this.companyLogoId = 1
    // storage.save('cache-companyName', '苏州恒赛特自动化科技有限公司')
    // storage.save('cache-companyLogoId', 1)
    // Bus.$emit('getCompanyName', '苏州恒赛特自动化科技有限公司')
    // // this.initdata()
    this.checkBrowser()
    this.loadCompanyInfo()
    this.initdata()
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    // 页面初始化读取数据
    initdata() {
      new Promise(resolve => {
        const data = settingsList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        for (let i = 0; i < res.length; i++) {
          const element = res[i]
          this.settings[element.key] = element.value
        }
        this.$forceUpdate()
        if (this.$refs.loginIdentify){
          setTimeout(() => {
            this.$refs.loginIdentify.$el.click()
          }, 50)
        }
      })
    },
    // 更新验证码
    getIdentifyCode(data) {
      this.identifyCode = data
      // console.log(this.identifyCode)
    },
    // 验证码输入验证
    handleIdentifyCode(rule, value, callback) {
      if (value) {
        value = value.toUpperCase()
      }
      console.log('zzzzzzzzzzzzzzzzzzzzzz')
      console.log(this.identifyCode)
      console.log(this.value)
      if (this.identifyCode == value) {
        this.identifyCodeStatus = 'success'
        this.identifyCodeHelp = ''
      } else {
        this.identifyCodeStatus = 'error'
        this.identifyCodeHelp = '验证码输入错误'
      }
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password'] : ['mobile', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = { ...values }
          delete loginParams.username
          loginParams[!state.loginType ? 'email' : 'username'] = values.username
          // loginParams.password = md5(values.password)
          loginParams.password = values.password
          if (this.identifyCodeIn) {
            this.identifyCodeIn = this.identifyCodeIn.toUpperCase()
          }
          if (this.settings.identifyCodeOpen == '0' || this.identifyCodeIn == this.identifyCode) {
            this.identifyCodeStatus = 'success'
            this.identifyCodeHelp = ''
            Login(loginParams)
              .then(res => this.loginSuccess(res))
              .catch(err => this.requestFailed(err))
              .finally(() => {
                state.loginBtn = false
              })
          } else {
            state.loginBtn = false
            this.identifyCodeStatus = 'error'
            this.identifyCodeHelp = '验证码输入错误'
          }
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          getSmsCaptcha({ mobile: values.mobile })
            .then(res => {
              setTimeout(hide, 2500)
              this.$notification['success']({
                message: '提示',
                description: '验证码获取成功，您的验证码为：' + res.result.captcha,
                duration: 8
              })
            })
            .catch(err => {
              setTimeout(hide, 1)
              clearInterval(interval)
              state.time = 60
              state.smsSendBtn = false
              this.requestFailed(err)
            })
        }
      })
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess(res) {
      // console.log('success:' + res)
      const code = res.code
      if (code === '0') {
        // this.$router.push({ path: '/' })
		this.$router.push({ path: '/' }, () => {}, () => {})
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        }, 1000)
      } else {
        // alert(res.message)
      }
    },
    requestFailed(err) {},
    loadCompanyInfo () {
       new Promise(resolve => {
        const data = getCompanyInfo({ }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (!res) return res
        this.companyName = res.name
        this.companyLogoId = res.logo
        if (res.name){
          storage.save("cache-companyName", res.name)
        }
        if (res.logo){
          storage.save("cache-companyLogoId", res.logo)
        }
        if (res.loginBg){
          storage.save("cache-loginBgId", res.loginBg)
        }
        Bus.$emit('getCompanyInfo', res)
      })
    },
    checkBrowser() {
       // 微信端不用提示
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 || navigator.userAgent.toLowerCase().indexOf('mobile') !== -1) {
        return
      }
      if (navigator.userAgent.toLowerCase().indexOf('chrome') < 0) {
        //this.isNotChrome = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.context {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
/*   align-items: center; */
}
.loginplat {
  width: 400px;
  height: 320px;
  padding: 10px;
/*   margin-top: -150px; */
  // background-image: url(/nav_gv.png);
  // background:url(/nav_gv1.png) repeat 0px 0px;
  background-size: 100% 100%;
  // background-color: rgba(0, 0, 0, 0.25);
  box-shadow: 5px 5px 10px 2px rgba(0,0,0,0.6);
  background-color: rgba(255, 255, 255, 0.6);
}
.forms{
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  border-radius: 5px;
}
.login-item{
  width: 260px;
  background-color: rgba(0, 0, 0, 0);
  cursor:url(/sb.ico),auto;
}
.ant-input-prefix,.ant-col,.ant-form-item-control-wrapper,
.ant-form-item-control,.has-success,
.login-item,.ant-input-affix-wrapper,.ant-input-affix-wrapper-lg{
  background-color: rgba(0,204,255, 1);
  border: 0px;
}
.content {
  width: 100%;
  height: 100%;
}
.content .logo {
  width: 160%;
  height: 100px;
  margin-top: -320px;
  margin-left: -100px;
}
.user-layout-login {
  font-size: 20px;
}
.user-layout-login {
  width: 310px;
  margin: -60px auto;
  padding: 20px;

  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
    background-color: #d8160e;
    border-color: #d8160e;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}

.identifyCode {
  display: -webkit-box;
  -webkit-box-align: center;
  display: box;
  box-align: center;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  .identifyCodei {
    width: 170px;
  }
  .identifyCodeid {
    width: 100px;
  }
}

.modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 10;
}

.modal-container {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    padding: 15px 40px;
}
</style>
